import React from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { displayDefaultDateFormater, mustBeArray } from '../../utils/lib';


const CollectionChart = ({data}) =>  {
    let graphData = mustBeArray(data).map(eachData => {
        return({...eachData, name: displayDefaultDateFormater({value: eachData.runDate})});
    });
    return(
        <div className="mb-1">
            <div className="text-center mb-1">{data[0] && data[0].locationName}</div>
            <ResponsiveContainer width="100%" height={320}>
                <BarChart
                    width={500}
                    height={300}
                    data={graphData}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                    >
                        <CartesianGrid strokeDasharray="3 3" display="none"  />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="expectedVolume" name="Expected Volume" fill="#8884d8" />
                        <Bar dataKey="actualVolume" name="Actual Volume" fill="#82ca9d" />
                    </BarChart>
            </ResponsiveContainer>
        </div>
    );
};
export default CollectionChart;